import type { BackendErrorCode } from "@/model/BackendErrors"

// Intended wire shape for the request the app sends to support when linking a device fails
export type DeviceLinkSupportRequestApiDto = {
  patientId: string
  imei: string
  errorCode: BackendErrorCode
}

// TODO: there is no backend endpoint for this yet, so the request resolves without a call.
export const createDeviceLinkSupportRequest = (
  params: DeviceLinkSupportRequestApiDto,
): Promise<void> => {
  console.info("Support request not sent, no backend endpoint yet", params)
  return Promise.resolve()
}
